<template>
  <div class="navbar-container" ref="navbarContainer">
    <!-- Racing Ticker -->
    <div v-if="showRacing" class="ticker-container racing">
      <div class="ticker-label">Next To Go Racing</div>
      <div class="ticker-content" ref="racingTicker">
        <div
          class="ticker-scroll"
          :style="{ transform: `translateX(-${racingOffset}px)` }"
        >
          <div class="ticker-items">
            <div
              v-for="(item, index) in racingData"
              :key="`racing-${index}`"
              class="ticker-item"
            >
              <span class="race-code">{{ item.code }}</span>
              <span class="race-track">{{ item.track }}</span>
              <span class="race-time">{{ item.time }}</span>
              <span class="race-odds">Odds: {{ item.odds }}</span>
            </div>
          </div>
          <!-- Duplicate for seamless loop -->
          <div class="ticker-items">
            <div
              v-for="(item, index) in racingData"
              :key="`racing-dup-${index}`"
              class="ticker-item"
            >
              <span class="race-code">{{ item.code }}</span>
              <span class="race-track">{{ item.track }}</span>
              <span class="race-time">{{ item.time }}</span>
              <span class="race-odds">Odds: {{ item.odds }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sport Ticker -->
    <div v-if="showSport" class="ticker-container sport">
      <div class="ticker-label">Next To Go Sport</div>
      <div class="ticker-content" ref="sportTicker">
        <div
          class="ticker-scroll"
          :style="{ transform: `translateX(-${sportOffset}px)` }"
        >
          <div class="ticker-items">
            <div
              v-for="(item, index) in sportData"
              :key="`sport-${index}`"
              class="ticker-item"
            >
              <span class="sport-event">{{ item.event }}</span>
              <span class="sport-time">{{ item.time }}</span>
              <span class="sport-hold">Hold: {{ item.hold }}</span>
              <span class="sport-liability"
                >Liability: {{ item.liability }}</span
              >
            </div>
          </div>
          <!-- Duplicate for seamless loop -->
          <div class="ticker-items">
            <div
              v-for="(item, index) in sportData"
              :key="`sport-dup-${index}`"
              class="ticker-item"
            >
              <span class="sport-event">{{ item.event }}</span>
              <span class="sport-time">{{ item.time }}</span>
              <span class="sport-hold">Hold: {{ item.hold }}</span>
              <span class="sport-liability"
                >Liability: {{ item.liability }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bet Stream Ticker -->
    <div v-if="showBetStream" class="ticker-container bet-stream">
      <div class="ticker-label">Bet Stream Ticker</div>
      <div class="ticker-content" ref="betStreamTicker">
        <div
          class="ticker-scroll"
          :style="{ transform: `translateX(-${betStreamOffset}px)` }"
        >
          <div class="ticker-items">
            <div
              v-for="(item, index) in betStreamData"
              :key="`bet-${index}`"
              class="ticker-item"
            >
              <span class="bet-user">{{ item.user }}</span>
              <span class="bet-amount">({{ item.amount }})</span>
              <span class="bet-details">{{ item.details }}</span>
            </div>
          </div>
          <!-- Duplicate for seamless loop -->
          <div class="ticker-items">
            <div
              v-for="(item, index) in betStreamData"
              :key="`bet-dup-${index}`"
              class="ticker-item"
            >
              <span class="bet-user">{{ item.user }}</span>
              <span class="bet-amount">({{ item.amount }})</span>
              <span class="bet-details">{{ item.details }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="nav-main-row d-flex align-items-center"
      style="padding: 0.8rem 1rem"
    >
      <!-- Nav Menu Toggler -->
      <b-link class="navbar-brand d-flex align-items-center" to="/" style="gap: 6px;">
        <b-img :src="appLogoImage" alt="MadridBet" style="height: 55px; width: auto;" />
      </b-link>

      <div class="link">
        <BLink
          v-for="item in navMenuItems"
          :key="item.name"
          :to="{ name: item.route }"
          :style="{
            color: $route.path.includes(`/${item.key}`) ? 'white' : 'black',
            padding: '5px 8px',
            fontSize: '13px',
            borderRadius: '8px',
            fontWeight: $route.path.includes(`/${item.key}`) ? 'bold' : '',
            backgroundColor: $route.path.includes(`/${item.key}`)
              ? '#155dfc'
              : 'white',
          }"
        >
          {{ item.title }}
        </BLink>
      </div>

      <!-- Left Col -->

      <b-navbar-nav class="nav align-items-center ml-auto">
        <!-- <div
          class="d-flex align-items-center mr-1 tickets-show"
          style="
            gap: 15px;
            border: 1px solid #dae1e7;
            background: #fbf9fa;
            padding: 4px 6px;
            border-radius: 8px;
          "
        >
          <span class="font-weight-bold" style="font-size: 12px">Tickers:</span>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showRacing" />
            Next To Go Racing
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showSport" />
            Next To Go Sport
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showBetStream" />
            Bet Stream Ticker
          </label>
        </div> -->
        <UserDropdown />
      </b-navbar-nav>
    </div>
    <div
      class="archive-bar"
      style="
        background: #fbf9fa;
        padding: 0.5rem 1rem;
        border: 1px solid #dae1e7;
      "
    >
      <div class="d-flex items-center justify-content-between flex-wrap">
        <div class="archive-content d-flex justify-content-between">
          <div>
            <span style="font-size: 13px"
              >Archive:
              {{ archiveUserName }}
              <template v-if="archiveLastLogin">
                | Logged in:
                {{ formatTime(archiveLastLogin, "yyyy-MM-dd hh:mm aa") }}
              </template>
            </span>
            <div style="margin-top: 3px">
              <b-breadcrumb
                class="p-0"
                style="font-size: 13px"
                :items="itemsNavbar()"
              ></b-breadcrumb>
            </div>
          </div>
        </div>

        <!-- Global Customer Search -->
        <div class="global-customer-search" ref="searchContainer">
          <div class="search-input-wrapper">
            <feather-icon icon="SearchIcon" size="15" class="search-icon" />
            <input
              v-model="search"
              type="text"
              ref="searchInput"
              class="gs-text-input"
              placeholder="Search customer..."
              @input="showDropdown = true; onSearchInput()"
              @focus="
                showDropdown = true;
                updateDropdownPosition();
              "
              @keydown.down.prevent="highlightNext"
              @keydown.up.prevent="highlightPrev"
              @keydown.enter.prevent="selectHighlighted"
              @keydown.esc="closeSearch"
              autocomplete="off"
            />
            <feather-icon
              v-if="search"
              icon="XIcon"
              size="14"
              class="clear-icon"
              @click="clearSearch"
            />
          </div>
          <div
            v-if="
              showDropdown &&
              (searchResults.length > 0 ||
                searchLoading ||
                (search && !searchLoading))
            "
            class="search-dropdown"
            :style="dropdownStyle"
          >
            <div
              v-if="searchLoading"
              class="search-dropdown-item search-loading"
            >
              <b-spinner small variant="primary" /> Searching...
            </div>
            <template v-else-if="searchResults.length > 0">
              <div
                v-for="(customer, idx) in searchResults"
                :key="customer.userId"
                class="search-dropdown-item"
                :class="{ highlighted: highlightedIndex === idx }"
                @mousedown.prevent="goToCustomer(customer)"
              >
                <div class="customer-name">
                  {{ customer.firstName }} {{ customer.lastName }}
                </div>
                <div class="customer-sub">
                  <span v-if="customer.email">{{ customer.email }}</span>
                </div>
              </div>
            </template>
            <div
              v-else-if="search && !searchLoading"
              class="search-dropdown-item search-empty"
            >
              No customers found
            </div>
          </div>
        </div>
      </div>
      <b-row v-if="$route.name === 'customers-view'" class="customer-summary">
        <!-- skeleton until the loaded customer matches the route id
             (avoids flashing the previous customer's data) -->
        <template v-if="customerLoading || !isCustomerLoaded">
          <b-col cols="12" md="6">
            <b-skeleton width="45%" class="mb-1" />
            <b-skeleton width="35%" />
          </b-col>
          <b-col cols="12" md="6">
            <b-skeleton width="55%" class="mb-1" />
            <b-skeleton width="40%" />
          </b-col>
        </template>
        <template v-else>
          <b-col cols="12" md="6">
            <p style="word-break: break-all">
              <span class="font-weight-bold"> Name:</span>
              {{
                `${customerData.user.firstName} ${customerData.user.lastName}`
              }}
            </p>
            <p style="word-break: break-all">
              <span class="font-weight-bold"> Phone:</span>
              {{ customerData.user.phoneNumber }}
            </p>
          </b-col>
          <b-col cols="12" md="6">
            <p style="word-break: break-all">
              <span class="font-weight-bold">Email:</span>
              {{ customerData.user.email }}
            </p>

            <div style="word-break: break-all">
              <p class="mb-0">
                <span class="font-weight-bold"> Balance Cash:</span>
              </p>
              <TokenBalances
                show-total
                class="text-muted"
                style="font-size: 12px"
                :balances="
                  customerData.dwalletBalance
                    ? customerData.dwalletBalance.balances
                    : []
                "
                :fallback-amount="customerData.user.balance || 0"
              />
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BBreadcrumb,
  BImg,
  BLink,
  BNavbarNav,
  BRow,
  BCol,
  BSpinner,
  BSkeleton,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import { debounce } from "debounce";
import UserDropdown from "./components/UserDropdown.vue";
import VerticalNavMenuItems from "../../layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import { $themeConfig } from "@themeConfig";
import { formatTime } from "@/helpers/utils";
import { showSidebarLeftRoute } from "@/@core/utils/enum/sidebar";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import TokenBalances from "@/views/apps/customers/components/TokenBalances.vue";

export default {
  components: {
    BLink,
    BNavbarNav,
    UserDropdown,
    TokenBalances,
    BSkeleton,
    VerticalNavMenuItems,
    BImg,
    BBreadcrumb,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      navMenuItems: [
        { route: "dashboard", title: "Dashboard", key: "dashboard" },
        { route: "customers", title: "Customers", key: "customer" },
        { route: "tradings-management", title: "Trading", key: "trading" },
        { route: "finance", title: "Finance", key: "finance" },
        { route: "settings", title: "Settings", key: "setting" },
      ],
      showRacing: false,
      showSport: false,
      showBetStream: false,
      racingOffset: 0,
      sportOffset: 0,
      betStreamOffset: 0,
      animationSpeed: 1,
      racingData: [],
      sportData: [],
      betStreamData: [],
      isShowLeftMenu: false,
      search: "",
      searchResults: [],
      searchLoading: false,
      showDropdown: false,
      highlightedIndex: -1,
      dropdownStyle: {},
    };
  },
  computed: {
    ...mapState("auth", ["user", "permissions"]),
    ...mapState({
      customerData: (s) => s.user.detail.userData,
      customerLoading: (s) => s.user.detail.loading,
    }),
    currentUser() {
      return (this.user && this.user.user) || null;
    },
    archiveUserName() {
      if (!this.currentUser) return "";
      const fullName = [this.currentUser.firstName, this.currentUser.lastName]
        .filter(Boolean)
        .join(" ");
      return `${fullName}${
        this.currentUser.username ? ` (${this.currentUser.username})` : ""
      }`.trim();
    },
    archiveLastLogin() {
      return (this.currentUser && this.currentUser.lastLoginDate) || null;
    },
    isCustomerLoaded() {
      const userId = this.customerData?.user?.userId;
      return !!userId && String(userId) === String(this.$route.params.id);
    },
  },
  created() {},
  mounted() {
    this.checkPermission();
    this.startAnimation();
    this.updateContentPadding();

    setTimeout(() => {
      this.updateContentPadding();
    }, 100);

    setTimeout(() => {
      this.updateContentPadding();
    }, 500);

    window.addEventListener("resize", this.updateContentPadding);
    document.addEventListener("click", this.onClickOutside);

    // ResizeObserver to track navbar height changes (e.g. nav links wrapping on mobile)
    if (window.ResizeObserver && this.$refs.navbarContainer) {
      this.navbarResizeObserver = new ResizeObserver(() => {
        this.updateContentPadding();
      });
      this.navbarResizeObserver.observe(this.$refs.navbarContainer);
    }
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    window.removeEventListener("resize", this.updateContentPadding);
    document.removeEventListener("click", this.onClickOutside);
    if (this.navbarResizeObserver) {
      this.navbarResizeObserver.disconnect();
    }
  },
  watch: {
    showRacing() {
      this.$nextTick(() => {
        this.updateContentPadding();
      });
    },
    showSport() {
      this.$nextTick(() => {
        this.updateContentPadding();
      });
    },
    showBetStream() {
      this.$nextTick(() => {
        this.updateContentPadding();
      });
    },
    $route(val) {
      if (val && typeof val.name === "string" && this.showSidebarLeftRoute.includes(val.name)) {
        this.$nextTick(() => {
          this.updateContentPadding();
        });
      }
    },
    customerData() {
      this.$nextTick(() => {
        this.updateContentPadding();
      });
    },
    permissions(val) {
      this.checkPermission();
    },
  },
  methods: {
    ...mapActions("user/list", ["getUserListBrief"]),
    formatCurrencyBuiltInFunc,
    onSearchInput: debounce(async function () {
      const q = this.search.trim();
      if (!q) {
        this.searchResults = [];
        this.highlightedIndex = -1;
        return;
      }
      this.searchLoading = true;
      try {
        const data = await this.getUserListBrief({
          search: q,
          limit: 10,
          page: 1,
        });
        this.searchResults = data || [];
        this.highlightedIndex = -1;
      } catch {
        this.searchResults = [];
      } finally {
        this.searchLoading = false;
      }
    }, 300),
    goToCustomer(customer) {
      if (this.$refs.searchInput) this.$refs.searchInput.blur();
      this.showDropdown = false;
      this.highlightedIndex = -1;
      this.$router.push({
        name: "customers-view",
        params: { id: customer.userId },
      });
    },
    clearSearch() {
      this.search = "";
      this.searchResults = [];
      this.showDropdown = false;
      this.highlightedIndex = -1;
    },
    closeSearch() {
      this.showDropdown = false;
      this.highlightedIndex = -1;
    },
    highlightNext() {
      if (this.highlightedIndex < this.searchResults.length - 1) {
        this.highlightedIndex++;
      }
    },
    highlightPrev() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    },
    selectHighlighted() {
      if (
        this.highlightedIndex >= 0 &&
        this.searchResults[this.highlightedIndex]
      ) {
        this.goToCustomer(this.searchResults[this.highlightedIndex]);
      }
    },
    updateDropdownPosition() {
      if (this.$refs.searchContainer) {
        const rect = this.$refs.searchContainer.getBoundingClientRect();
        this.dropdownStyle = {
          top: `${rect.bottom + 4}px`,
          left: `${rect.left}px`,
          width: `${rect.width}px`,
        };
      }
    },
    onClickOutside(e) {
      if (
        this.$refs.searchContainer &&
        !this.$refs.searchContainer.contains(e.target)
      ) {
        this.closeSearch();
      }
    },
    capitalizeWords(str) {
      return str
        .replace(/-/g, " ")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    itemsNavbar() {
      const dashboard = {
        text: "Dashboard",
        href: "",
      };
      const path = this.$router.currentRoute.fullPath;
      const parts = path.split("/").filter(Boolean);
      const part1 = parts[0];
      if (part1 === "dashboard") return [dashboard];
      if (parts.length === 1) {
        return [
          dashboard,
          {
            text: this.capitalizeWords(part1),
            href: `/${part1}`,
          },
        ];
      }
      if (parts.length > 1) {
        const part2 = parts[1];
        return [
          dashboard,
          {
            text: this.capitalizeWords(part1),
            href: `/${part1}`,
          },
          {
            text: this.capitalizeWords(part2),
            href: this.$router.currentRoute.fullPath,
          },
        ];
      }
    },
    startAnimation() {
      const animate = () => {
        //  Constrain scrolling to viewport width to prevent overflow
        if (this.showRacing && this.$refs.racingTicker) {
          const containerWidth = this.$refs.racingTicker.offsetWidth;
          const contentWidth = containerWidth * 2; // Since we duplicate content
          this.racingOffset += this.animationSpeed;
          if (this.racingOffset >= contentWidth / 2) {
            this.racingOffset = 0;
          }
        }

        if (this.showSport && this.$refs.sportTicker) {
          const containerWidth = this.$refs.sportTicker.offsetWidth;
          const contentWidth = containerWidth * 2;
          this.sportOffset += this.animationSpeed;
          if (this.sportOffset >= contentWidth / 2) {
            this.sportOffset = 0;
          }
        }

        if (this.showBetStream && this.$refs.betStreamTicker) {
          const containerWidth = this.$refs.betStreamTicker.offsetWidth;
          const contentWidth = containerWidth * 2;
          this.betStreamOffset += this.animationSpeed;
          if (this.betStreamOffset >= contentWidth / 2) {
            this.betStreamOffset = 0;
          }
        }

        this.animationFrame = requestAnimationFrame(animate);
      };
      animate();
    },
    updateContentPadding() {
      this.$nextTick(() => {
        try {
          const navbarElement = this.$refs.navbarContainer;
          if (navbarElement) {
            const navbarHeight = navbarElement.offsetHeight;
            const contentElement = document.querySelector(
              ".app-content.content"
            );

            const leftSidebarElement = document.querySelector(
              ".main-menu.menu-fixed"
            );

            if (contentElement) {
              contentElement.style.paddingTop = `${navbarHeight + 20}px`;
            }
            if (leftSidebarElement) {
              leftSidebarElement.style.top = `${navbarHeight}px`;
            }
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
    checkPermission() {
      const permissionKeyMap = {
        dashboard: ["dashboard"],
        customer: ["customer", "bdm_customer"],
        trading: ["trading"],
        finance: ["finance"],
        setting: ["settings"],
      };
      const allItems = [
        { route: "dashboard", title: "Dashboard", key: "dashboard" },
        { route: "customers", title: "Customers", key: "customer" },
        { route: "tradings-management", title: "Trading", key: "trading" },
        { route: "finance", title: "Finance", key: "finance" },
        { route: "settings", title: "Settings", key: "setting" },
      ];
      if (this.permissions && this.permissions.full_access === "admin") {
        this.navMenuItems = allItems;
        return;
      }
      this.navMenuItems = allItems.filter((item) => {
        const permKeys = permissionKeyMap[item.key];
        if (!permKeys) return true;
        return permKeys.some(
          (key) => this.permissions[key] && this.permissions[key] !== "none"
        );
      });
    },
  },
  setup(props) {
    const { appLogoImage } = $themeConfig.app;
    return {
      appLogoImage,
      formatTime,
      showSidebarLeftRoute,
    };
  },
};
</script>

<style lang="scss" scoped>
.global-customer-search {
  position: relative;
  flex-shrink: 0;
  align-self: center;
  width: 100%;
  @media screen and (min-width: 768px) {
    width: 300px;
  }
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #dae1e7;
  border-radius: 8px;
  padding: 4px 10px;
  gap: 6px;
  min-width: 220px;
  transition: border-color 0.2s;
  background: #fff;
  &:focus-within {
    border-color: #155dfc;
    background: #fff;
  }
}

.search-icon {
  flex-shrink: 0;
}

.clear-icon {
  flex-shrink: 0;
  cursor: pointer;
}

.gs-text-input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
}

.search-dropdown {
  position: fixed;
  background: #fff;
  border: 1px solid #dae1e7;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 9999;
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0 8px 8px 0;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    &:hover {
      background: #999;
    }
  }
}

.search-dropdown-item {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.highlighted {
    background: #f0f5ff;
  }

  &.search-loading,
  &.search-empty {
    cursor: default;
    color: #9ca3af;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: transparent;
    }
  }
}

.customer-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.customer-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.link {
  display: flex;
  gap: 5px;
  color: black !important;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-size: 11px;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
}

.ticker-container {
  display: flex;
  align-items: center;
  height: 40px;
  /*  Constrain ticker to viewport width */
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
}

.ticker-container.racing {
  background: #4a5565;
}

.ticker-container.sport {
  background: #155dfc;
}

.ticker-container.bet-stream {
  background: #00a63e;
}

.ticker-label {
  color: white;
  font-weight: bold;
  padding: 4px 10px;
  font-size: 13px;
  white-space: nowrap;
  /*  Ensure label doesn't take too much space */
  flex-shrink: 0;
  min-width: 140px;
  background: #101828;
}

.ticker-content {
  flex: 1;
  overflow: hidden;
  /*  Ensure content area respects container bounds */
  width: 100%;
  max-width: 100%;
}

.ticker-scroll {
  display: flex;
  will-change: transform;
}

.ticker-items {
  display: flex;
  /*  Ensure items don't wrap and stay in single line */
  flex-shrink: 0;
  white-space: nowrap;
}

.ticker-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 24px;
  color: white;
  font-size: 13px;
  /*  Prevent items from breaking layout */
  flex-shrink: 0;
  white-space: nowrap;
}

.race-code,
.race-track,
.race-time,
.race-odds,
.sport-event,
.sport-time,
.sport-hold,
.sport-liability,
.bet-user,
.bet-amount,
.bet-details {
  /*  Ensure all text elements don't wrap */
  white-space: nowrap;
}

.race-code {
  font-weight: bold;
}

.race-track {
  font-weight: 500;
}

.sport-event {
  font-weight: 500;
}

.bet-user {
  font-weight: bold;
  color: #ffd700;
}

.bet-amount {
  color: #90ee90;
}

@media (max-width: 1247px) {
  .tickets-show {
    display: none !important;
  }
}

/* === RESPONSIVE — Tablet === */
@media (max-width: 991px) {
  .navbar-container {
    max-width: 100vw;
    overflow-x: hidden;
  }

  .nav-main-row {
    flex-wrap: wrap;
    padding: 0.5rem 0.75rem !important;
    gap: 6px;
  }

  .link {
    flex-wrap: wrap;
    gap: 4px;
    order: 3;
    width: 100%;
  }

  .link a {
    font-size: 11px !important;
    padding: 4px 6px !important;
  }

  .ticker-container {
    height: 32px;
    width: 100%;
    max-width: 100%;
  }

  .ticker-label {
    font-size: 11px;
    min-width: 110px;
    padding: 3px 8px;
  }

  .ticker-item {
    font-size: 11px;
    gap: 8px;
    padding: 0 16px;
  }

  .archive-bar {
    padding: 0.4rem 0.75rem !important;
  }

  .archive-content {
    flex-direction: column;
    gap: 8px;
  }

  .archive-content span {
    font-size: 12px !important;
  }
}

/* === RESPONSIVE — Mobile === */
@media (max-width: 767px) {
  .nav-main-row {
    padding: 0.4rem 0.5rem !important;
  }

  .link {
    gap: 3px;
  }

  .link a {
    font-size: 10px !important;
    padding: 3px 5px !important;
    border-radius: 6px !important;
  }

  .ticker-container {
    height: 28px;
  }

  .ticker-label {
    font-size: 10px;
    min-width: 80px;
    padding: 2px 6px;
  }

  .ticker-item {
    font-size: 10px;
    gap: 6px;
    padding: 0 12px;
  }

  .archive-bar {
    padding: 0.3rem 0.5rem !important;
  }

  .archive-content span {
    font-size: 11px !important;
  }

  .archive-content .row {
    width: 100%;
  }

  .customer-summary p {
    font-size: 11px;
    margin-bottom: 2px;
  }
}

/* === RESPONSIVE — Small Mobile (≤575px) === */
@media (max-width: 575px) {
  .nav-main-row {
    padding: 0.3rem 0.4rem !important;
    gap: 4px;
  }

  .link a {
    font-size: 9px !important;
    padding: 2px 4px !important;
  }

  .customer-summary {
    display: none !important;
  }

  .archive-content span {
    font-size: 10px !important;
  }

  .archive-bar {
    padding: 0.25rem 0.4rem !important;
  }
}
</style>
